// Keyset paging has no page numbers, so Previous is the cursor of the page before this one. The
// trail is the cursors already visited; Next pushes the current one, Previous pops. Anything that
// changes the ordering or the filter empties it, because those cursors belong to a view that no
// longer exists.

import { useState } from 'react';

export default function usePageTrail({ query, page, apply, withCursor }) {
  const [trail, setTrail] = useState([]);

  const reset = () => setTrail([]);

  const onNext = () => {
    setTrail((visited) => [...visited, query.cursor]);
    apply(withCursor(query, page.next_cursor));
  };

  const onPrevious = () => {
    const previous = trail.length > 0 ? trail[trail.length - 1] : null;
    setTrail((visited) => visited.slice(0, -1));
    apply(withCursor(query, previous));
  };

  return { hasPrevious: trail.length > 0, reset, onNext, onPrevious };
}
